import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseResourceService } from '../../shared/services/base-resource.service';
import { Notification } from './notification.model';
import { MetaPaginationInterface } from '../../shared/interfaces/fields-pagination.interface';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificationService extends BaseResourceService<Notification> {

    private apiUrlWorker = environment.API_URL_WORKER;

    constructor(protected injector: Injector) {

        super('notifications', injector, Notification.fromJson);
    }

    public getNotifications(): Observable<{ data: Notification[], meta: MetaPaginationInterface }> {
        const params = this.paramsBuilder( { others: { noLoader: true }} );
        return this.http.get(this.apiUrlWorker + 'realtime/notifications', {params}).pipe(
            map(this.jsonDataToResources.bind(this)),
            catchError(this.handleError)
        );
    }
}
